import React from "react";

const DashboardPanel = (props) => {
  const { title, comment, headerAction, footer, withBorder, theme, className } = props;

  const classes = [
    "panel",
    theme,
    comment ? "withComment" : null,
    className,
  ];
  const headerClasses = [
    "header",
    withBorder ? "withBorder" : null,
  ];
  const bodyClasses = [
    "body",
    footer ? "withFooter" : null,
  ];
  const footerElem = footer && (
    <div className="footer">
      { footer }
    </div>
  );
  
  return (
    <div className={classes.join(" ")}>
      <div className={headerClasses.join(" ")}>
        <div className="bgColorTheme" />
        <h1>{ title }</h1>
        { comment && <p className="comment">{ comment }</p> }
        <div className="dashboardHeaderAction">{ headerAction }</div>
      </div>
      <div className={bodyClasses.join(" ")}>
        { props.children }
      </div>
      { footerElem }
    </div>
  );
}

export default DashboardPanel;